import React, { useState } from "react";
import "../componentCss/webform.css";
import "../componentCss/sidebar.css";
import "react-toastify/dist/ReactToastify.css";
import DataTable from 'react-data-table-component';
import { Modal, Button } from 'react-bootstrap';
import {
  updateRxStatusAction
} from "../../Action/admin.action";
import toast, { Toaster } from "react-hot-toast";

const moment = require('moment');

const PrescriptionList = ({ancillaryDrugAssignedList, getPrescriptionAssignListAPI}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [selectedRx, setSelectedRx] = useState(null);

  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };

  const handleViewRxDetails = (drugData) => {
    try {
      if (drugData.rxData) {
        const parsedRxData = JSON.parse(drugData.rxData);
        const selectedRxItem = JSON.parse(parsedRxData).find(item => item.id === drugData.drugId);

        setSelectedRx(selectedRxItem);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error parsing rxData:", error);
    }
  };

  let updateRxStatus = async (status, id) => {
    let res = await updateRxStatusAction({ status, id });
    if (res.success) {
      toast.success(res.msg)
      getPrescriptionAssignListAPI()
    } else {
      toast.error(res.msg)
    }
  };

  const columns = [
    {
      name: '#',
      cell: (row, index, column, id) => {
        return index + 1 + currentPage * rowsPerPage;
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Drug Name',
      selector: row => row.drugName,
      sortable: true,
      width: "17%"
    },
    {
      name: 'Drug Code',
      selector: row => row.drugCode,
      width: "17%"
    },
    {
      name: 'Rx Start Datetime',
      selector: row => (
        <>
          {moment(row.rxStartDate).format("YYYY-MM-DD")} {row.rxStartTime}
        </>
      ),
      width: "18%"
    },
    {
      name: 'Rx Cut Datetime',
      selector: row => (
        <>
          {moment(row.rxCutDate).format("YYYY-MM-DD")} {row.rxCutTime}
        </>
      ),
      width: "18%"
    },
    {
      name: 'Scheduling',
      selector: row => row.scheduling,
      width: "17%"
    },
    {
      name: 'Scheduling Days',
      selector: row => (
        <>
          {JSON.parse(row?.schedulingDays).length > 0 ?
            <>
              {JSON.parse(row.schedulingDays).map((day, index) => (
                <li key={index}>{day}</li>
              ))}
            </>
            : 'NA'}
        </>
      ),
      width: "15%"
    },
    {
      name: 'Custom Times',
      selector: row => (
        <>
          {JSON.parse(row?.administeringCustomTimesData).length > 0 ?
            <>
              {JSON.parse(row.administeringCustomTimesData).map((day, index) => (
                <li key={index}>{day}</li>
              ))}
            </>
            : 'NA'}
        </>
      ),
      width: "15%"
    },
    {
      name: 'Status',
      selector: row => (
        <span className={row.status == 1 ? "text-success fw-bold" : "text-danger fw-bold"}>
          {row.status == 1 ? "Running" : "Stopped"}
        </span>
      )
    },
    {
      name: 'Action',
      selector: row => (
        <>
          <button className="btn btn-sm btn-primary" onClick={() => handleViewRxDetails(row)}>
            View Rx Details
          </button>
          &nbsp;&nbsp;
          {row.status == 1 ? (
            <button className="btn btn-sm btn-danger" onClick={() => updateRxStatus(row.status, row.id)}>
              Stop
            </button>
          ) : (
            <button className="btn btn-sm btn-primary" onClick={() => updateRxStatus(row.status, row.id)}>
              Activate
            </button>
          )}
        </>
      ),
      width: "25%"
    },
  ];

  return (
    <>
      {ancillaryDrugAssignedList?.length > 0 ?
        <div>
          <DataTable
            columns={columns}
            data={ancillaryDrugAssignedList}
            pagination
            paginationPerPage={rowsPerPage}
            paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
            paginationComponentOptions={{
              rowsPerPageText: 'Row per page:',
              rangeSeparatorText: 'out of',
            }}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        </div>
        :
        <div style={{ textAlign: 'center' }}>
          No Data Found
        </div>
      }
      {/* Modal for Rx Details */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary fw-bold">Rx Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRx ? (
            <div className="container">
              <div className="row mb-3">
                <div className="col-md-6">
                  <p><strong className="text-secondary">Drug Code:</strong> {selectedRx.drugcode || 'NA'}</p>
                </div>
                <div className="col-md-6">
                  <p><strong className="text-secondary">Package Name:</strong> {selectedRx.packagename || 'NA'}</p>
                </div>
              </div>

              <div className="card shadow-sm p-3">
                <h5 className="text-primary border-bottom pb-2">Prescription Details</h5>
                <ul className="list-unstyled mt-3">
                  {Object.entries(selectedRx.rxData).map(([key, value], index) => (
                    <li key={index} className="d-flex">
                      <span className="text-secondary fw-bold col-5">{key}:</span>
                      <span className="text-dark col-7">{value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            <p className="text-center text-danger">No details available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default PrescriptionList;
